/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yaml` */
/* eslint-disable @typescript-eslint/ban-types,no-duplicate-imports */
import { DocumentNode } from 'graphql'
import gql from 'graphql-tag'
export type ProfessionalApplicationFieldsFragment = (
  Pick<ProfessionalApplication, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'postalCode' | 'gender' | 'city' | 'careerStartDate' | 'website' | 'instagram' | 'categories' | 'old_qualifications' | 'employmentHistory' | 'careerHighlights' | 'verified' | 'status' | 'old_documents' | 'createdAt' | 'verifiedDate' | 'insuranceExpiryDate' | 'note' | 'userId' | 'referral' | 'referralName' | 'bio' | 'currentSituation' | 'currentSituationOther' | 'bookingsPerWeek' | 'interviewDate'>
  & { qualifications?: Maybe<Array<Maybe<(
    Pick<Qualification, 'title' | 'dateObtained'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, documents?: Maybe<Array<Maybe<(
    Pick<ApplicationDocument, 'title' | 'dateAdded' | 'expiryDate' | 'status'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>> }
);

export type GetUploadAuthTokenQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type GetUploadAuthTokenQuery = { getUploadAuthToken?: Maybe<Pick<AuthToken, 'role' | 'auth'>> };

export type AddProfessionalApplicationMutationVariables = Exact<{
  data?: InputMaybe<ProfessionalApplicationInput>;
}>;

export type AddProfessionalApplicationMutation = { addProfessionalApplication?: Maybe<Pick<ProfessionalApplication, '_id'>> };

export type FetchExistingApplicationMutationVariables = Exact<{
  mobile: Scalars['String'];
  emailAddress: Scalars['String'];
}>;

export type FetchExistingApplicationMutation = { fetchExistingApplication?: Maybe<(
  Pick<ProfessionalApplication, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'postalCode' | 'gender' | 'city' | 'careerStartDate' | 'website' | 'instagram' | 'categories' | 'old_qualifications' | 'employmentHistory' | 'careerHighlights' | 'bio' | 'old_documents' | 'status' | 'currentSituation' | 'currentSituationOther' | 'bookingsPerWeek' | 'referral' | 'referralName' | 'interviewDate'>
  & { qualifications?: Maybe<Array<Maybe<(
    Pick<Qualification, 'title' | 'dateObtained'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, documents?: Maybe<Array<Maybe<(
    Pick<ApplicationDocument, 'title' | 'dateAdded' | 'expiryDate' | 'status'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>> }
)> };

export type UpdateProfessionalApplicationMutationVariables = Exact<{
  _id: Scalars['String'];
  data?: InputMaybe<ProfessionalApplicationInput>;
}>;

export type UpdateProfessionalApplicationMutation = { updateProfessionalApplication?: Maybe<(
  Pick<ProfessionalApplication, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'postalCode' | 'gender' | 'city' | 'careerStartDate' | 'website' | 'instagram' | 'categories' | 'old_qualifications' | 'employmentHistory' | 'careerHighlights' | 'bio' | 'old_documents' | 'status' | 'currentSituation' | 'currentSituationOther' | 'bookingsPerWeek' | 'referral' | 'referralName' | 'interviewDate'>
  & { qualifications?: Maybe<Array<Maybe<(
    Pick<Qualification, 'title' | 'dateObtained'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, documents?: Maybe<Array<Maybe<(
    Pick<ApplicationDocument, 'title' | 'dateAdded' | 'expiryDate' | 'status'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>> }
)> };

export type ProfessionalApplicationQueryVariables = Exact<{
  _id: Scalars['String'];
  emailAddress: Scalars['String'];
}>;

export type ProfessionalApplicationQuery = { professionalApplication?: Maybe<(
  Pick<ProfessionalApplication, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'mobile' | 'postalCode' | 'gender' | 'city' | 'careerStartDate' | 'website' | 'instagram' | 'categories' | 'old_qualifications' | 'employmentHistory' | 'careerHighlights' | 'bio' | 'referral' | 'referralName' | 'status' | 'old_documents' | 'currentSituation' | 'currentSituationOther' | 'bookingsPerWeek' | 'interviewDate'>
  & { qualifications?: Maybe<Array<Maybe<(
    Pick<Qualification, 'title' | 'dateObtained'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>>, documents?: Maybe<Array<Maybe<(
    Pick<ApplicationDocument, 'title' | 'dateAdded' | 'expiryDate' | 'status'>
    & { files?: Maybe<Array<Maybe<Pick<UploadDocument, 'url' | 'status'>>>> }
  )>>> }
)> };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload'];
  path?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  resizeOptions?: InputMaybe<ResizeImageOptions>;
}>;

export type UploadFileMutation = Pick<Mutation, 'uploadFile'>;

export type DeleteFileMutationVariables = Exact<{
  filename?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  directory?: InputMaybe<Scalars['String']>;
}>;

export type DeleteFileMutation = Pick<Mutation, 'deleteFile'>;

export type CallConfirmationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;

export type CallConfirmationQuery = Pick<Query, 'callConfirmation'>;

export type InAppMessagesQueryVariables = Exact<{
  filter: InAppMessageFilter;
}>;

export type InAppMessagesQuery = { inAppMessages: Array<Pick<InAppMessage, '_id' | 'name' | 'platform' | 'eventName' | 'match' | 'contentType' | 'updatedAt'>> };

export type InAppMessageQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type InAppMessageQuery = { inAppMessage?: Maybe<Pick<InAppMessage, 'name' | 'content'>> };

export const ProfessionalApplicationFieldsFragmentDoc = gql`
    fragment ProfessionalApplicationFields on ProfessionalApplication {
  _id
  firstName
  lastName
  emailAddress
  mobile
  postalCode
  gender
  city
  careerStartDate
  website
  instagram
  categories
  qualifications {
    title
    dateObtained
    files {
      url
      status
    }
  }
  old_qualifications
  employmentHistory
  careerHighlights
  verified
  status
  documents {
    title
    dateAdded
    expiryDate
    status
    files {
      url
      status
    }
  }
  old_documents
  createdAt
  verifiedDate
  insuranceExpiryDate
  note
  userId
  referral
  referralName
  bio
  currentSituation
  currentSituationOther
  bookingsPerWeek
  interviewDate
}
    `
export const GetUploadAuthTokenDocument = gql`
    query getUploadAuthToken($_id: String!) {
  getUploadAuthToken(_id: $_id) {
    role
    auth
  }
}
    `
export const AddProfessionalApplicationDocument = gql`
    mutation addProfessionalApplication($data: ProfessionalApplicationInput) {
  addProfessionalApplication(data: $data) {
    _id
  }
}
    `
export const FetchExistingApplicationDocument = gql`
    mutation fetchExistingApplication($mobile: String!, $emailAddress: String!) {
  fetchExistingApplication(mobile: $mobile, emailAddress: $emailAddress) {
    _id
    firstName
    lastName
    emailAddress
    mobile
    postalCode
    gender
    city
    careerStartDate
    website
    instagram
    categories
    qualifications {
      title
      dateObtained
      files {
        url
        status
      }
    }
    old_qualifications
    employmentHistory
    careerHighlights
    bio
    documents {
      title
      dateAdded
      expiryDate
      status
      files {
        url
        status
      }
    }
    old_documents
    status
    currentSituation
    currentSituationOther
    bookingsPerWeek
    referral
    referralName
    interviewDate
  }
}
    `
export const UpdateProfessionalApplicationDocument = gql`
    mutation updateProfessionalApplication($_id: String!, $data: ProfessionalApplicationInput) {
  updateProfessionalApplication(_id: $_id, data: $data) {
    _id
    firstName
    lastName
    emailAddress
    mobile
    postalCode
    gender
    city
    careerStartDate
    website
    instagram
    categories
    qualifications {
      title
      dateObtained
      files {
        url
        status
      }
    }
    old_qualifications
    employmentHistory
    careerHighlights
    bio
    documents {
      title
      dateAdded
      expiryDate
      status
      files {
        url
        status
      }
    }
    old_documents
    status
    currentSituation
    currentSituationOther
    bookingsPerWeek
    referral
    referralName
    interviewDate
  }
}
    `
export const ProfessionalApplicationDocument = gql`
    query professionalApplication($_id: String!, $emailAddress: String!) {
  professionalApplication(_id: $_id, emailAddress: $emailAddress) {
    _id
    firstName
    lastName
    emailAddress
    mobile
    postalCode
    gender
    city
    careerStartDate
    website
    instagram
    categories
    qualifications {
      title
      dateObtained
      files {
        url
        status
      }
    }
    old_qualifications
    employmentHistory
    careerHighlights
    bio
    referral
    referralName
    status
    documents {
      title
      dateAdded
      expiryDate
      status
      files {
        url
        status
      }
    }
    old_documents
    currentSituation
    currentSituationOther
    bookingsPerWeek
    interviewDate
  }
}
    `
export const UploadFileDocument = gql`
    mutation uploadFile($file: Upload!, $path: String, $filename: String, $type: String, $resizeOptions: ResizeImageOptions) {
  uploadFile(
    file: $file
    path: $path
    filename: $filename
    type: $type
    resizeOptions: $resizeOptions
  )
}
    `
export const DeleteFileDocument = gql`
    mutation deleteFile($filename: String, $type: String, $directory: String) {
  deleteFile(filename: $filename, type: $type, directory: $directory)
}
    `
export const CallConfirmationDocument = gql`
    query callConfirmation($id: String) {
  callConfirmation(id: $id)
}
    `
export const InAppMessagesDocument = gql`
    query inAppMessages($filter: InAppMessageFilter!) {
  inAppMessages(filter: $filter) {
    _id
    name
    platform
    eventName
    match
    contentType
    updatedAt
  }
}
    `
export const InAppMessageDocument = gql`
    query inAppMessage($_id: String!) {
  inAppMessage(_id: $_id) {
    name
    content
  }
}
    `
export type Requester<C= {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R>
export function getSdk<C>(requester: Requester<C>) {
  return {
    getUploadAuthToken(variables: GetUploadAuthTokenQueryVariables, options?: C): Promise<GetUploadAuthTokenQuery> {
      return requester<GetUploadAuthTokenQuery, GetUploadAuthTokenQueryVariables>(GetUploadAuthTokenDocument, variables, options)
    },
    addProfessionalApplication(variables?: AddProfessionalApplicationMutationVariables, options?: C): Promise<AddProfessionalApplicationMutation> {
      return requester<AddProfessionalApplicationMutation, AddProfessionalApplicationMutationVariables>(AddProfessionalApplicationDocument, variables, options)
    },
    fetchExistingApplication(variables: FetchExistingApplicationMutationVariables, options?: C): Promise<FetchExistingApplicationMutation> {
      return requester<FetchExistingApplicationMutation, FetchExistingApplicationMutationVariables>(FetchExistingApplicationDocument, variables, options)
    },
    updateProfessionalApplication(variables: UpdateProfessionalApplicationMutationVariables, options?: C): Promise<UpdateProfessionalApplicationMutation> {
      return requester<UpdateProfessionalApplicationMutation, UpdateProfessionalApplicationMutationVariables>(UpdateProfessionalApplicationDocument, variables, options)
    },
    professionalApplication(variables: ProfessionalApplicationQueryVariables, options?: C): Promise<ProfessionalApplicationQuery> {
      return requester<ProfessionalApplicationQuery, ProfessionalApplicationQueryVariables>(ProfessionalApplicationDocument, variables, options)
    },
    uploadFile(variables: UploadFileMutationVariables, options?: C): Promise<UploadFileMutation> {
      return requester<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, variables, options)
    },
    deleteFile(variables?: DeleteFileMutationVariables, options?: C): Promise<DeleteFileMutation> {
      return requester<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, variables, options)
    },
    callConfirmation(variables?: CallConfirmationQueryVariables, options?: C): Promise<CallConfirmationQuery> {
      return requester<CallConfirmationQuery, CallConfirmationQueryVariables>(CallConfirmationDocument, variables, options)
    },
    inAppMessages(variables: InAppMessagesQueryVariables, options?: C): Promise<InAppMessagesQuery> {
      return requester<InAppMessagesQuery, InAppMessagesQueryVariables>(InAppMessagesDocument, variables, options)
    },
    inAppMessage(variables: InAppMessageQueryVariables, options?: C): Promise<InAppMessageQuery> {
      return requester<InAppMessageQuery, InAppMessageQueryVariables>(InAppMessageDocument, variables, options)
    },
  }
}
export type Sdk = ReturnType<typeof getSdk>;